// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3Sa1x","photo":"Card_photo__1R2p-","fadeIn":"Card_fadeIn__1Nzzb","fade":"Card_fade__2Jnv8","name":"Card_name__1JQFv"};